import * as types from '../../actions/types';

const initialState = {
  isLoading: false,
  errorStatus: null,
};

export default function currentStatus (state = initialState, action) {
  switch (action.type) {

    case types.COMPLEX_THEME_PLAN_STREAM_CURRENT_FETCH_STARTED:
      return { isLoading: true, errorStatus: null };

    case types.COMPLEX_TOPICS_DISCIPLINES_SET_CURRENT:
      return { isLoading: false, errorStatus: null };

    case types.COMPLEX_THEME_PLAN_STREAM_CURRENT_FETCH_ERROR:
      return { isLoading: false, errorStatus: action.errorStatus };

    default:
      return state;
  }
}
